import { AppBar, Toolbar, Typography } from '@material-ui/core'
import React from 'react'
import { useNavigate } from 'react-router';

const AppBarComp = () => {
    const p = require('../../../package.json');
    const ver = process.env.REACT_APP_COMMIT_TAG || p.version;
    console.log('Current deployment is', process.env, process.env.REACT_APP_COMMIT_TAG, process.env.REACT_APP_TEST)
    const naviagte = useNavigate()
    return (
        <AppBar position='static'>
            <Toolbar style={{ background: '#292D39' }} >
                <Typography onClick={() => naviagte('/')} style={{ marginLeft: '1rem', textTransform: 'uppercase', fontSize: 16, fontWeight: 'bold', letterSpacing: 1, cursor: 'pointer', color: '#fff' }} variant='h5'>Instalimb Modeler {ver}</Typography>
            </Toolbar>
        </AppBar >
    )
}

export default AppBarComp